import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2a57abe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shipping-details-quantity" }
const _hoisted_2 = { class: "shipping-details-quantity__title" }

import BaseSlider from '@/components/base/BaseSlider.vue';
import { useMyStore } from '@/v2/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShippingDetailsQuantityV2',
  setup(__props) {

const store = useMyStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('shippingDetailsQuantity_title')), 1),
    _createVNode(BaseSlider, {
      mark: { 1: '1', 10: '10' },
      min: 1,
      max: 10,
      "tooltip-visible": _unref(store).loading === 0,
      onChange: _unref(store).changeQuantity,
      disabled: _unref(store).state.getting
    }, null, 8, ["tooltip-visible", "onChange", "disabled"])
  ]))
}
}

})